import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Avatar,
  useTheme
} from '@mui/material';
import { 
  Business as BusinessIcon, 
  Person as PersonIcon 
} from '@mui/icons-material';
import { useResponsive } from '../../hooks/useResponsive';
import { UserTypeOption } from '../../types/auth';

interface UserTypeSelectorProps {
  onSelect: (type: 'executor' | 'business') => void;
}

const userTypeOptions: UserTypeOption[] = [
  {
    type: 'business',
    title: 'Бизнес',
    description: 'Я хочу размещать задания для подростков',
    icon: '🏢'
  },
  {
    type: 'executor',
    title: 'Подросток',
    description: 'Хочу выполнять задания и зарабатывать',
    icon: '👤'
  }
];

export const UserTypeSelector: React.FC<UserTypeSelectorProps> = ({ onSelect }) => {
  const theme = useTheme();
  const { isMobile } = useResponsive();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {userTypeOptions.map((option) => (
        <Card
          key={option.type}
          sx={{
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            '&:hover': {
              borderColor: theme.palette.primary.main,
              transform: 'translateY(-2px)',
              boxShadow: theme.shadows[8],
            },
            '&:active': {
              transform: 'translateY(0)',
            }
          }}
          onClick={() => onSelect(option.type)}
        >
          <CardContent
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              p: isMobile ? 2 : 3,
            }}
          >
            {/* Иконка */}
            <Avatar
              sx={{
                width: isMobile ? 48 : 56,
                height: isMobile ? 48 : 56,
                backgroundColor: theme.palette.primary.main,
                fontSize: isMobile ? '1.5rem' : '1.8rem',
              }}
            >
              {option.type === 'business' ? (
                <BusinessIcon sx={{ fontSize: isMobile ? 24 : 28 }} />
              ) : (
                <PersonIcon sx={{ fontSize: isMobile ? 24 : 28 }} />
              )}
            </Avatar>

            {/* Текст */}
            <Box sx={{ flex: 1 }}>
              <Typography
                variant={isMobile ? "h6" : "h5"}
                sx={{
                  fontWeight: 'bold',
                  color: '#1a1a1a',
                  mb: 0.5,
                }}
              >
                {option.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#666',
                  fontSize: isMobile ? '0.85rem' : '0.95rem',
                }}
              >
                {option.description}
              </Typography>
            </Box>

            {/* Стрелка */}
            <Box
              sx={{
                color: theme.palette.primary.main,
                fontSize: '1.5rem',
                fontWeight: 'bold',
              }}
            >
              →
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};
